module.exports = __webpack_public_path__ + "img/admox-QR.4a642dd0.png";